import React from 'react';
import { createContext } from "react";

import { AuthService } from "../services/interfaces";

interface AuthProviderProps {
  children: React.ReactNode;
  authService: AuthService;
};

export const AuthContext = createContext<AuthService | undefined>(undefined);

export const AuthProvider = ({ children, authService }: AuthProviderProps) => {
  return (
    <AuthContext.Provider value={authService}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthService {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthServiceProvider');
  }
  return context;
};
